const priorityRules = {
  date: (type) => {
    const rules = {
      pickup: ['dropoff_time_from', 'dropoff_time_to'],
    };
    return rules[type] ? rules[type] : false;
  },
  time: (type) => {
    const rules = {
      pickup_time_from: [
        'pickup_time_to',
        'dropoff_time_from',
        'dropoff_time_to',
      ],
      pickup_time_to: ['dropoff_time_from', 'dropoff_time_to'],
      dropoff_time_from: ['dropoff_time_to'],
    };
    return rules[type] ? rules[type] : false;
  },
};

export default priorityRules;
